import { useContext, useMemo } from 'react';
import MiniDrawer from './Login/Main';
import { AuthContext } from './Global/AuthContext';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { RoutersComponent } from "./Global/RouterComponent";
import {LoginUser} from "./Login/Login";

function App() {
    const {logged, theme} = useContext(AuthContext);

    const themeDefault = useMemo(
        ()=>
        createTheme({
            palette:{
                mode: theme.MUI,
            }
        }),
        [theme.MUI]
    )

    return (
        <ThemeProvider theme={themeDefault}>
            {
                logged?
                    <MiniDrawer>
                        <RoutersComponent/>
                    </MiniDrawer> : <LoginUser/>
            }

        </ThemeProvider>
      
    );
}

export default App;
